import { Drawer } from 'antd';
import { Button } from 'components/Button';
import FilterSelect from "components/Form/filterSelect";
import { useCallback,useEffect,useState } from 'react';
import { useSelector } from 'react-redux';

const UniformAllocationFilterDrawer = ({
   
    searchPlaceholder,
    handleFilterDrawer,
    showFilterDrawer,
    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleDateChange

}) => {
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState('right');  
   const {
    userData, userDataLoading,
    department, departmentLoading ,
    position, positionLoading,
    costCenterLoading, costCenter
} = useSelector((state) => state.common);


const [positionOption, setPositionOption] = useState([]);
const [costCenterOption, setCostCenterOption] = useState([]);



useEffect(()=>{
   
   

    let _position = position?.map(item=> {
      return{
          label: item.name,
          value: item.id
      }
  })
  let cost_center = costCenter.map(item=> {
    return{
        label: item.code,
        value: item.id
    }
})
setCostCenterOption(cost_center)
setPositionOption(_position)  

},[userData, position])




   const setFilterValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        if(selectedValue?.value){
            return selectedValue
    
        }
    }

    return ""

  }, [filters]);


  const setInputValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        return selectedValue?.value
    }
    return ""

  }, [filters]);

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const onChange = (e) => {
    setPlacement(e.target.value);
  };
  return (
    <>
      <Drawer
        title="Basic Drawer"
        placement={placement}
        closable={true}
        onClose={handleFilterDrawer}
        open={showFilterDrawer}
        key={placement}
      >
         <div className="col mb-3 d-flex justify-content-between">
          <h3 className="page-title">Filters</h3>
          <i onClick={handleFilterDrawer}  className='la la-close cursor-pointer ' />
        </div>

    

        <div className='col-12 mb-3' >
          {/* Deptment Filter */}
          <FilterSelect isClearable={true} isLoading={positionLoading} onChange={e=>{handleFilterChange(e, "position")}} optionLabel={"label"} optionValue={'value'} options={positionOption} value={setFilterValue("position")} placeholder={"Select Position"}/>
        </div>

        <div className='col-12 mb-3' >
         {/* Cost Filter */}
         <FilterSelect isClearable={true} isLoading={costCenterLoading} onChange={e=>{handleFilterChange(e, "cost_center")}} optionLabel={"label"} optionValue={'value'} options={costCenterOption} value={setFilterValue("cost_center")} placeholder={"Cost Center"}/>
        </div>



        <div className="col-12">
          <Button label="Search" loading={filterLoading} disabled={filterLoading} onClick={handleApplyFilter}   className="btn btn-primary  w-100"/>    
     
       </div>

      </Drawer>
    </>
  );
};
export default UniformAllocationFilterDrawer;